export default {
	props: {
		totalSelecionado: {
			type: Number,
			default: 0,
		},
		loadingAtendimentoRapido: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['criar:atendimento', 'limpar:atendimento'],
	data() {
		return {
			optionsSelects: {
				optionsPoliticaAtendimentoRapido: [
					{ value: '0', label: 'Política de atendimento' },
					{ value: '1', label: 'Outro' },
				],
			},
			model: {
				politicaAtendimentoRapido: null,
				menssagemPoliticaAtendimentoRapido: '',
			},
		}
	},
	computed: {
		isFormValid() {
			return this.model.politicaAtendimentoRapido && this.totalSelecionado > 0
		},
		labelSelecionados() {
			return `${this.totalSelecionado} ${this.totalSelecionado === 1 ? 'Item Selecionado' : 'Itens Selecionados'}`
		},
	},
	methods: {
		limparAtendimentoRapido() {
			this.resetForm()
			this.$emit('limpar:atendimento')
		},

		criarAtendimento() {
			if (!this.isFormValid) return

			this.$emit(
				'criar:atendimento',
				this.model.politicaAtendimentoRapido?.value,
				this.model.menssagemPoliticaAtendimentoRapido
			)
		},

		resetForm() {
			this.model.politicaAtendimentoRapido = null
			this.model.menssagemPoliticaAtendimentoRapido = ''
		},
	},
	watch: {
		totalSelecionado(newVal) {
			if (newVal === 0) {
				this.resetForm()
			}
		},
	},
	template: `<div class="
        fixed 
        bottom-0 
        inset-x-0 
        w-full
        h-[5rem]
        !pl-[279px]
        !pr-[190px]
        bg-white
        shadow-[0px_-4px_12px_rgba(0,0,0,0.1)]
        transition-transform duration-300
        z-50">
        <form @submit.stop.prevent="criarAtendimento" class="w-full h-full">
            <div class="flex justify-between items-center w-full h-full bg-white mx-auto px-24">
                <div class="flex items-center h-full">
                    <q-checkbox 
                        size="xs" 
                        indeterminate-value="maybe" 
                        :label="labelSelecionados" 
                        color="primary-pure"
                        :model-value="true"
                        @click="limparAtendimentoRapido"/>
                </div>
                <div class="flex items-center gap-16 h-full">
                    <q-select 
                        outlined 
                        v-model="model.politicaAtendimentoRapido" 
                        :label="model.politicaAtendimentoRapido ? '': 'Política padrão'" 
                        class="min-w-[11rem]"  
                        :options="optionsSelects.optionsPoliticaAtendimentoRapido" 
                        />
                    <q-input 
                        outlined 
                        v-model="model.menssagemPoliticaAtendimentoRapido" 
                        :label="model.menssagemPoliticaAtendimentoRapido ? '': 'Mensagem padrão...'" 
                        class="w-[20rem]" 
                        input-class="primary-pure"/>
                    <q-btn
                        type="submit"
                        class="btn h-48 primary"
                        :loading="loadingAtendimentoRapido"
                        :disable="!isFormValid"
                        >
                        Enviar atendimento
                    </q-btn>
                </div>
            </div>
        </form>
    </div>`,
}
